//@flow

import {connect} from 'react-redux';
import Congrats from './Congrats';
import {isLoadingSelector} from '../../../modules/LoadingStatus';
import {resetToDashboard} from '../../../modules/Navigation/actions';
import {portabilityCharacteristicsSelector} from '../../../modules/SignUp/PhoneNumber/reducer';
import {errorTitleSelector} from '../../../modules/LoadingStatus/reducer';
import {eSimSelectedSelector} from '../../../modules/ESim';
import {installESim} from '../../../modules/ESim/actions';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'redirectAfterActivating'),
  error: errorTitleSelector(state, 'redirectAfterActivating'),
  isRequestingPortability: !!portabilityCharacteristicsSelector(state),
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps = dispatch => ({
  goToDashboard: () => resetToDashboard(),
  redirectAfterActivationFailed: () => resetToDashboard(),
  installESim: () => dispatch(installESim()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Congrats);
